var map = {
	"./3a.svg": 8079,
	"./adaptive.svg": 5541,
	"./ai.svg": 2185,
	"./android.svg": 9920,
	"./api.svg": 3897,
	"./concurrent.svg": 6736,
	"./contact.svg": 853,
	"./cross-platform.svg": 6279,
	"./director.svg": 4295,
	"./education-icon.svg": 2103,
	"./feature-default.svg": 1803,
	"./flexible.svg": 3326,
	"./hd.svg": 5047,
	"./high-quality.svg": 143,
	"./introduction.svg": 4495,
	"./layers.svg": 3465,
	"./live-icon.svg": 6149,
	"./lowlatency.svg": 6363,
	"./mix.svg": 5735,
	"./multiscene.svg": 994,
	"./protocols.svg": 9754,
	"./realtime.svg": 752,
	"./scale.svg": 927,
	"./screens.svg": 1726,
	"./security.svg": 861,
	"./soft.svg": 5123,
	"./switch.svg": 935,
	"./video-icon.svg": 4370,
	"./voip.svg": 2893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;